export default __webpack_public_path__ + "static/media/autonomous_brave.7c3f7f13.png";